module.exports = __webpack_public_path__ + "static/img/Beach.80a8888.png";